import { useState, useEffect, useRef } from "react";
import { isMobile } from "react-device-detect";
import { Link } from "react-router-dom";
import cx from "classnames";

// CSS
import styles from "../header.module.scss";

export const HeaderFilters = (props) => {
    const {
        clearTags,
        handleSelectFilter,
        handleToggleSearchMode,
        shouldShowFilterTags,
    } = props;

    /**
     * useRef
     */

    const locationsTabRef = useRef();

    /**
     * useState
     */

    const [tabWidth, setTabWidth] = useState(null);

    /**
     * useEffect
     */

    useEffect(() => {
        if (locationsTabRef?.current) {
            setTabWidth(locationsTabRef.current.clientWidth);
        }
    }, [locationsTabRef]);

    /**
     * Constants
     */

    const tabStyle = { width: tabWidth ? `${tabWidth}px` : "auto" };

    /**
     * End Hooks
     */

    function handleShowAllClick() {
        clearTags();
        handleToggleSearchMode(false);
    }

    function onMouseEnter() {
        if (!isMobile) {
            handleSelectFilter("tags", true);
        }
    }

    return (
        <div className={styles.filters}>
            <div className={styles.filterBy}>
                <span>FILTER BY</span>
            </div>
            <div className={styles.tabs}>
                <div
                    className={cx(styles.tab, {
                        [styles["tab--selected"]]: shouldShowFilterTags,
                    })}
                    onClick={() => handleSelectFilter("tags")}
                    onMouseEnter={onMouseEnter}
                    style={tabStyle}
                >
                    FILTER BY
                    <span className={cx(styles.arrow, "material-icons")}>
                        arrow_drop_up
                    </span>
                </div>
            </div>
            <div className={styles.showAll}>
                <Link
                    className={styles.link}
                    onClick={handleShowAllClick}
                    to="/videos"
                >
                    SHOW ALL
                </Link>
            </div>
        </div>
    );
};
